import { render } from "./Registermerchant.vue?vue&type=template&id=6dedc463&scoped=true"
import script from "./Registermerchant.vue?vue&type=script&lang=js"
export * from "./Registermerchant.vue?vue&type=script&lang=js"

import "./Registermerchant.vue?vue&type=style&index=0&id=6dedc463&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dedc463"]])

export default __exports__